<ng-container *ngIf="data">
  <!-- Title -->
  <div *ngIf="mainHeader != null" class="Availability-header Availability-header--semi-bold">
    <div class="Availability-title">{{ mainHeader | uppercase }}</div>
    <div class="close-icon" (click)="onCancel()" *ngIf="isModal">
      <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon>
    </div>
  </div>

  <!-- Custom Options -->
  <div *ngIf="customOptions$ | async as customOptions" class="more-filters-custom-options-wrapper">
    <miq-section-options
      *ngFor="let customOption of customOptions"
      [sectionSettings]="customOption"
      [columnsByRow]="customOption.columnsByRow"
    ></miq-section-options>
  </div>

  <!-- Table Columns -->
  <ng-container>
    <div class="Availability-header">
      <miq-section-options-filter
        [title]="dialogOptions.title"
        [placeholder]="'admin.searchAttribute' | xTranslate"
        [showCancelButton]="isModal"
        [searchFormControl]="searchFormControl"
        (cancel)="onCancel()"
        [class.isModal]="isModal"
        [ngClass]="{ 'Availability-header--bold': mainHeader == null }"
      ></miq-section-options-filter>

      <div class="close-icon" (click)="onCancel()" *ngIf="isModal && mainHeader == null">
        <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon>
      </div>
    </div>
    <div class="availablefilters-dialog" [ngClass]="{ 'availablefilters-dialog--reduce-height': hasCustomOptions }">
      <div mat-dialog-content [class.isModal]="isModal">
        <div class="filters-catalog">
          <!--Pinned filters without title-->
          <div *ngIf="pinnedFiltersCatalog?.length > 0" class="pinned-filters-left-side">
            <ng-container *ngFor="let filterSettings of pinnedFiltersCatalog">
              <ng-container *ngFor="let filter of filterSettings.filters">
                <div
                  class="filters"
                  [ngStyle]="{
                    'pointer-events': isCheckboxDisabled(filter) ? 'none' : 'all',
                  }"
                >
                  <mat-checkbox
                    #checkbox
                    [checked]="!!filter.checked"
                    [disabled]="isCheckboxDisabled(filter)"
                    [ngClass]="{ 'p-chkbox p-chkbox-box': filterForTableView }"
                    (click)="onCkboxToggle(checkbox, filterSettings.sectionId, filterSettings.title, filter)"
                  >
                    <span [matTooltip]="filter.tooltip" matTooltipPosition="below">
                      {{ filter.value }}
                    </span>
                  </mat-checkbox>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <div class="filter-message" *ngIf="dialogOptions.message">{{ dialogOptions.message }}</div>
          <div *ngIf="filtersCatalog?.length === 0" class="nodata-label" l10nTranslate>shared.noDataToShow</div>
          <!-- Usage Checkboxes that are shown only for Search Property entity -->
          <ng-container *ngIf="showAllPropertyData && checkboxState">
            <mat-checkbox [(ngModel)]="showPropertyData" (click)="onCheckboxChange($event)" style="margin-bottom: 20px">
              <span l10nTranslate>shared.showAllPropertyData</span>
            </mat-checkbox>
          </ng-container>

          <!-- Filters by Section-->
          <div *ngIf="filtersCatalog?.length !== 0" class="left-side">
            <div *ngFor="let filterSettings of filtersCatalog">
              <h3 class="lbl-dialogSubHdr filter-title">{{ filterSettings.title }}</h3>
              <div class="filter-section" [class.isModal]="isModal">
                <ng-container *ngFor="let filter of filterSettings.filters">
                  <div
                    *ngIf="!filter.pinned"
                    class="filters"
                    [ngStyle]="{
                      'pointer-events': isCheckboxDisabled(filter) ? 'none' : 'all',
                    }"
                  >
                    <mat-checkbox
                      #checkbox
                      [checked]="!!filter.checked"
                      [disabled]="isCheckboxDisabled(filter)"
                      [ngClass]="{ 'p-chkbox p-chkbox-box': filterForTableView }"
                      (click)="onCkboxToggle(checkbox, filterSettings.sectionId, filterSettings.title, filter)"
                    >
                      <span [matTooltip]="filter.tooltip" matTooltipPosition="below">
                        {{ filter.value }}
                      </span>
                    </mat-checkbox>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <aside *ngIf="!filterForRecords">
          <div class="selectedfilter-header">
            <div class="selectedfilter-header__title" l10nTranslate>shared.selectedFilters</div>
            <div (click)="onClear()" class="selectedfilter-header__clear" l10nTranslate>shared.clearFilters</div>
          </div>
          <div *ngIf="userFilters?.length !== 0">
            <div *ngFor="let userFilter of userFilters">
              <div class="appliedfilter-title">{{ userFilter.title }}</div>
              <mat-chip-listbox class="mrf-chip-list">
                <mat-chip-option
                  class="selected-filter-option"
                  [selectable]="false"
                  [removable]="true"
                  (removed)="onRemove(userFilter.title, filter)"
                  *ngFor="let filter of userFilter.filters"
                >
                  {{ filter.value }}<mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip-option>
              </mat-chip-listbox>
            </div>
          </div>
          <div *ngIf="userFilters?.length === 0" class="nofilter-label" l10nTranslate>shared.noFiltersToSelect</div>
        </aside>
      </div>
    </div>
  </ng-container>

  <!-- Action Buttons -->
  <ng-container *ngIf="isModal">
    <div mat-dialog-actions *ngIf="!filterForRecords; else filterForRecords">
      <button mat-button color="primary" class="fx--mr-sm" (click)="onReset()" l10nTranslate>shared.reset</button>
      <button mat-flat-button color="primary" (click)="applySelections()" l10nTranslate [disabled]="customOptionsError">
        shared.add
      </button>
    </div>
    <ng-template #filterForRecords>
      <div class="availability-actions">
        <button
          mat-button
          color="primary"
          class="fx--mr-sm"
          *ngIf="!isFilterDialog"
          (click)="resetToDefaultColumns()"
          l10nTranslate
        >
          shared.reset
        </button>
        <button
          mat-flat-button
          color="primary"
          (click)="applySelections()"
          l10nTranslate
          [disabled]="customOptionsError"
        >
          shared.save
        </button>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
